export const androidSteps = [
  {
    title: "确认系统版本",
    desc: "进入「设置 → 关于手机」查看安卓版本，建议 Android 8.0 及以上再继续下载，避免安装后无法运行。",
  },
  {
    title: "获取 APK 安装包",
    desc: "从本页安卓版入口下载对应版本的安装包，下载过程中请保持网络稳定，避免文件下载不完整导致解析失败。",
  },
  {
    title: "允许安装未知来源应用",
    desc: "打开「设置 → 安全 → 更多安全设置 → 安装未知应用」，找到当前正在使用的浏览器或文件管理器并允许安装。",
  },
  {
    title: "点击安装并等待完成",
    desc: "在通知栏或文件管理器中打开已下载的安装包，点击「安装」，等待进度条走完，期间请勿锁屏或中断。",
  },
  {
    title: "授权基础运行权限",
    desc: "首次打开会请求网络、存储与通知权限，建议按需开启，存储权限用于缓存视频，通知权限用于追更提醒。",
  },
  {
    title: "登录并进入视频社区",
    desc: "注册或登录账号后，选择感兴趣的标签，首页即会按你的偏好生成内容流，即可开始浏览与互动。",
  },
];

export const androidNotes = [
  "下载完成后若提示「解析包错误」，多为文件未下载完整，删除后重新下载即可。",
  "部分品牌机型需在安装界面单独关闭「安全检测」提示，按屏幕指引继续即可。",
  "若系统提示已安装过旧版本，建议先卸载旧版再安装，避免版本冲突。",
];

export const iosSteps = [
  {
    title: "确认系统版本",
    desc: "进入「设置 → 通用 → 关于本机」查看系统版本，建议 iOS 13.0 及以上，iPad 需 iPadOS 13 及以上。",
  },
  {
    title: "获取苹果版安装包",
    desc: "从本页苹果版入口按引导下载安装包或测试版描述文件，整个过程需保持网络连接，中途不要退出页面。",
  },
  {
    title: "信任开发者描述文件",
    desc: "安装后若提示「未受信任的企业级开发者」，前往「设置 → 通用 → VPN 与设备管理」，找到对应描述文件并点击信任。",
  },
  {
    title: "首次启动完成授权",
    desc: "首次打开会请求网络与通知权限，按提示允许即可；若无法联网，可检查是否开启了相关网络限制。",
  },
  {
    title: "登录并进入视频社区",
    desc: "使用账号登录后设置兴趣标签，即可开始浏览短视频、长视频与直播内容，并参与弹幕与评论互动。",
  },
];

export const iosNotes = [
  "若描述文件无法信任，可先删除已安装的描述文件与应用，重启后按步骤重新安装。",
  "企业级证书可能因有效期到期而失效，遇到无法打开时请回到本页重新获取最新安装包。",
  "升级 iOS 系统后，建议重新打开应用确认权限与信任状态是否仍生效。",
];